/**
 *
 * UpdateProfile
 *
 */
import React, { memo, useState, useEffect } from "react";
import { ProfileForm } from "./components/profile-form";
import { RequestSubmission } from "./components/request-submission";

interface Props {}

export const UpdateProfile = memo((props: Props) => {
  const [isRequestSubmitted, setIsRequestSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [isRequestSubmitted]);

  return (
    <div className="px-3 py-3 sm:px-4 md:px-6 lg:px-8 2xl:px-12 sm:py-4 md:py-5 lg:py-[1.625rem]">
      {isRequestSubmitted ? (
        <RequestSubmission />
      ) : (
        <div className="w-full max-w-[50.1875rem] mx-auto">
          <h6 className="inline-flex items-center gap-[0.31rem] font-roboto text-black text-[0.625rem] font-medium leading-[0.9375rem] tracking-[0.00938rem] mb-2.5 sm:mb-4 md:mb-5 lg:mb-6">
            <span className="text-[#FE4D01]">Customer Information</span> /{" "}
            <span>Update Profile</span>
          </h6>
          <ProfileForm setIsRequestSubmitted={setIsRequestSubmitted} />
        </div>
      )}
    </div>
  );
});
